module.exports = __webpack_public_path__ + "img/KY.de8886b0.svg";